'use client';

import { __makeTemplateObject } from '../../_virtual/_tslib.js';
import styled, { css } from 'styled-components';

var Container = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    blockquote {\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n    }\n"], ["\n    blockquote {\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n    }\n"])), function (_a) {
    var minWidth = _a.minWidth;
    return minWidth
        ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                      min-width: ", "px !important;\n                  "], ["\n                      min-width: ", "px !important;\n                  "])), minWidth) : undefined;
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth
        ? css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                      max-width: ", "px !important;\n                  "], ["\n                      max-width: ", "px !important;\n                  "])), maxWidth) : undefined;
}, function (_a) {
    var width = _a.width;
    return width
        ? css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                      width: ", "px !important;\n                  "], ["\n                      width: ", "px !important;\n                  "])), width) : undefined;
}, function (_a) {
    var height = _a.height;
    return height
        ? css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n                      height: ", "px !important;\n                  "], ["\n                      height: ", "px !important;\n                  "])), height) : undefined;
}, function (_a) {
    var overflow = _a.overflow;
    return overflow
        ? css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n                      overflow: ", "px !important;\n                  "], ["\n                      overflow: ", "px !important;\n                  "])), overflow) : undefined;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

export { Container };
//# sourceMappingURL=styled.js.map
